import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // Defer pixel loading to not block initial render
    const loadPixel = () => {
      if (window.fbq) return

      const n: any = (window.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!window._fbq) window._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const t = document.createElement('script')
      t.async = true
      t.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(t)

      window.fbq('init', '1475153193972129')
      window.fbq('track', 'PageView')
    }

    // Use requestIdleCallback if available, otherwise setTimeout
    if ('requestIdleCallback' in window) {
      ;(window as any).requestIdleCallback(loadPixel)
    } else {
      setTimeout(loadPixel, 2000)
    }
  }, [])
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Invisibles pero Invencibles - Guía + Bonos',
      content_type: 'product',
      value: 17.89,
      currency: 'USD',
    })
  }
}
